import z from 'zod';

export enum QuizTimedMode {
  PRACTICE = 'PRACTICE',
  TIMED = 'TIMED',
  TIMED_PER_QUESTION = 'TIMED_PER_QUESTION',
}

export const quizTimedModeSchema = z.enum(QuizTimedMode);
